'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports["default"] = StepOne;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VisualPicker = require('../../VisualPicker');

var _VisualPicker2 = _interopRequireDefault(_VisualPicker);

var _VisualPickerOption = require('../../VisualPickerOption');

var _VisualPickerOption2 = _interopRequireDefault(_VisualPickerOption);

var _VisualPickerOptionFooter = require('../../VisualPickerOptionFooter');

var _VisualPickerOptionFooter2 = _interopRequireDefault(_VisualPickerOptionFooter);

var _RenderIf = require('../../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _Select = require('../../Select');

var _Select2 = _interopRequireDefault(_Select);

var _addRecords = require('../icons/addRecords');

var _addRecords2 = _interopRequireDefault(_addRecords);

var _mergeRecords = require('../icons/mergeRecords');

var _mergeRecords2 = _interopRequireDefault(_mergeRecords);

var _getSchemaFieldOptions = require('../helpers/getSchemaFieldOptions');

var _getSchemaFieldOptions2 = _interopRequireDefault(_getSchemaFieldOptions);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function StepOne(props) {
  var schemaFields = props.schemaFields,
      actionOption = props.actionOption,
      onChangeAction = props.onChangeAction,
      matchField = props.matchField,
      onChangeMatchField = props.onChangeMatchField;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      fieldOptions = _useState2[0],
      setFieldOptions = _useState2[1];

  var isMergeOption = actionOption === 'merge-records';
  (0, _react.useEffect)(function () {
    setFieldOptions((0, _getSchemaFieldOptions2["default"])(schemaFields));
  }, [schemaFields]);
  return _react2["default"].createElement('div', {
    className: 'rainbow-import-records-flow_step-one-container'
  }, _react2["default"].createElement(_VisualPicker2["default"], {
    className: 'rainbow-import-records-flow_step-one-visual-picker',
    label: 'Select the option type that do you want to do',
    onChange: onChangeAction,
    value: actionOption
  }, _react2["default"].createElement(_VisualPickerOption2["default"], {
    name: 'add-records',
    footer: _react2["default"].createElement(_VisualPickerOptionFooter2["default"], {
      label: 'Add new records'
    })
  }, _react2["default"].createElement(_addRecords2["default"], null)), _react2["default"].createElement(_VisualPickerOption2["default"], {
    name: 'merge-records',
    footer: _react2["default"].createElement(_VisualPickerOptionFooter2["default"], {
      label: 'Merge exist records'
    })
  }, _react2["default"].createElement(_mergeRecords2["default"], null))), _react2["default"].createElement(_RenderIf2["default"], {
    isTrue: isMergeOption
  }, _react2["default"].createElement(_Select2["default"], {
    label: 'Match Field',
    placeholder: 'Select the Field do you want match',
    options: fieldOptions,
    onChange: function onChange(event) {
      return onChangeMatchField(event.target.value);
    },
    value: matchField
  })));
}

StepOne.propTypes = {
  schemaFields: _propTypes2["default"].array,
  actionOption: _propTypes2["default"].string,
  onChangeAction: _propTypes2["default"].func,
  matchField: _propTypes2["default"].string,
  onChangeMatchField: _propTypes2["default"].func
};
StepOne.defaultProps = {
  schemaFields: [],
  actionOption: '',
  onChangeAction: function onChangeAction() {},
  matchField: '',
  onChangeMatchField: function onChangeMatchField() {}
};